import { render } from "./ColunaKanban.vue?vue&type=template&id=361adc68&scoped=true&ts=true"
import script from "./ColunaKanban.vue?vue&type=script&lang=ts"
export * from "./ColunaKanban.vue?vue&type=script&lang=ts"

import "./ColunaKanban.vue?vue&type=style&index=0&id=361adc68&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361adc68"]])

export default __exports__